/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntermediaryClientPlanDetail
 */
export interface IntermediaryClientPlanDetail {
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    bookOfBusinessCode?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    sourceSystemCode?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    sourceSystemGroupCode?: string;
    /**
     * 
     * @type {Date}
     * @memberof IntermediaryClientPlanDetail
     */
    effectiveStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IntermediaryClientPlanDetail
     */
    effectiveEndDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    intermediaryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    planNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    investmentName?: string;
    /**
     * 
     * @type {Date}
     * @memberof IntermediaryClientPlanDetail
     */
    inceptionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    planActiveFlag?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    productCode?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    productType?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    productCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    productProvider?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    jockeyFlag?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    serviceFlag?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    exBrokerFlag?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientPartyType?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientInitials?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientLastName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientDisplayName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientPreferredName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientIdentificationNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof IntermediaryClientPlanDetail
     */
    clientDateOfBirth?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientPassportNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientPassportCountryOfIssuance?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientCompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientCompanyRegistrationNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof IntermediaryClientPlanDetail
     */
    clientCompanyInceptionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientMaritalStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    employmentStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    fICAStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    mobileNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    addressStreetFarmPlotName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    workTelephone?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    homeTelephone?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    nationalityCountry?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    residenceCountry?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    postalAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    industry?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    sourceOfMoney?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    companyContactPerson?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    tradingName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    countryOfIncorporation?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    countryOfOperation?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    sector?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    contactPerson?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    intermediaryType?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    intermediaryFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    intermediaryLastName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    intermediaryDisplayName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    intermediaryPreferredName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    intermediaryCellphoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    intermediaryEmailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    brokerageCode?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    brokerageName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetail
     */
    clientPartySubType?: string;
}

/**
 * Check if a given object implements the IntermediaryClientPlanDetail interface.
 */
export function instanceOfIntermediaryClientPlanDetail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntermediaryClientPlanDetailFromJSON(json: any): IntermediaryClientPlanDetail {
    return IntermediaryClientPlanDetailFromJSONTyped(json, false);
}

export function IntermediaryClientPlanDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntermediaryClientPlanDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bookOfBusinessCode': !exists(json, 'BookOfBusinessCode') ? undefined : json['BookOfBusinessCode'],
        'sourceSystemCode': !exists(json, 'SourceSystemCode') ? undefined : json['SourceSystemCode'],
        'sourceSystemGroupCode': !exists(json, 'SourceSystemGroupCode') ? undefined : json['SourceSystemGroupCode'],
        'effectiveStartDate': !exists(json, 'EffectiveStartDate') ? undefined : (new Date(json['EffectiveStartDate'])),
        'effectiveEndDate': !exists(json, 'EffectiveEndDate') ? undefined : (new Date(json['EffectiveEndDate'])),
        'intermediaryCode': !exists(json, 'IntermediaryCode') ? undefined : json['IntermediaryCode'],
        'clientNumber': !exists(json, 'ClientNumber') ? undefined : json['ClientNumber'],
        'planNumber': !exists(json, 'PlanNumber') ? undefined : json['PlanNumber'],
        'investmentName': !exists(json, 'InvestmentName') ? undefined : json['InvestmentName'],
        'inceptionDate': !exists(json, 'InceptionDate') ? undefined : (new Date(json['InceptionDate'])),
        'planActiveFlag': !exists(json, 'PlanActiveFlag') ? undefined : json['PlanActiveFlag'],
        'productCode': !exists(json, 'ProductCode') ? undefined : json['ProductCode'],
        'productName': !exists(json, 'ProductName') ? undefined : json['ProductName'],
        'productType': !exists(json, 'ProductType') ? undefined : json['ProductType'],
        'productCategory': !exists(json, 'ProductCategory') ? undefined : json['ProductCategory'],
        'productProvider': !exists(json, 'ProductProvider') ? undefined : json['ProductProvider'],
        'jockeyFlag': !exists(json, 'JockeyFlag') ? undefined : json['JockeyFlag'],
        'serviceFlag': !exists(json, 'ServiceFlag') ? undefined : json['ServiceFlag'],
        'exBrokerFlag': !exists(json, 'ExBrokerFlag') ? undefined : json['ExBrokerFlag'],
        'clientPartyType': !exists(json, 'ClientPartyType') ? undefined : json['ClientPartyType'],
        'clientTitle': !exists(json, 'ClientTitle') ? undefined : json['ClientTitle'],
        'clientInitials': !exists(json, 'ClientInitials') ? undefined : json['ClientInitials'],
        'clientFirstName': !exists(json, 'ClientFirstName') ? undefined : json['ClientFirstName'],
        'clientLastName': !exists(json, 'ClientLastName') ? undefined : json['ClientLastName'],
        'clientDisplayName': !exists(json, 'ClientDisplayName') ? undefined : json['ClientDisplayName'],
        'clientPreferredName': !exists(json, 'ClientPreferredName') ? undefined : json['ClientPreferredName'],
        'clientIdentificationNumber': !exists(json, 'ClientIdentificationNumber') ? undefined : json['ClientIdentificationNumber'],
        'clientDateOfBirth': !exists(json, 'ClientDateOfBirth') ? undefined : (new Date(json['ClientDateOfBirth'])),
        'clientPassportNumber': !exists(json, 'ClientPassportNumber') ? undefined : json['ClientPassportNumber'],
        'clientPassportCountryOfIssuance': !exists(json, 'ClientPassportCountryOfIssuance') ? undefined : json['ClientPassportCountryOfIssuance'],
        'clientCompanyName': !exists(json, 'ClientCompanyName') ? undefined : json['ClientCompanyName'],
        'clientCompanyRegistrationNumber': !exists(json, 'ClientCompanyRegistrationNumber') ? undefined : json['ClientCompanyRegistrationNumber'],
        'clientCompanyInceptionDate': !exists(json, 'ClientCompanyInceptionDate') ? undefined : (new Date(json['ClientCompanyInceptionDate'])),
        'clientMaritalStatus': !exists(json, 'ClientMaritalStatus') ? undefined : json['ClientMaritalStatus'],
        'country': !exists(json, 'Country') ? undefined : json['Country'],
        'email': !exists(json, 'Email') ? undefined : json['Email'],
        'employmentStatus': !exists(json, 'EmploymentStatus') ? undefined : json['EmploymentStatus'],
        'fICAStatus': !exists(json, 'FICAStatus') ? undefined : json['FICAStatus'],
        'mobileNumber': !exists(json, 'MobileNumber') ? undefined : json['MobileNumber'],
        'taxNumber': !exists(json, 'TaxNumber') ? undefined : json['TaxNumber'],
        'addressStreetFarmPlotName': !exists(json, 'AddressStreetFarmPlotName') ? undefined : json['AddressStreetFarmPlotName'],
        'workTelephone': !exists(json, 'WorkTelephone') ? undefined : json['WorkTelephone'],
        'homeTelephone': !exists(json, 'HomeTelephone') ? undefined : json['HomeTelephone'],
        'nationalityCountry': !exists(json, 'NationalityCountry') ? undefined : json['NationalityCountry'],
        'residenceCountry': !exists(json, 'ResidenceCountry') ? undefined : json['ResidenceCountry'],
        'postalAddress': !exists(json, 'PostalAddress') ? undefined : json['PostalAddress'],
        'industry': !exists(json, 'Industry') ? undefined : json['Industry'],
        'sourceOfMoney': !exists(json, 'SourceOfMoney') ? undefined : json['SourceOfMoney'],
        'companyContactPerson': !exists(json, 'CompanyContactPerson') ? undefined : json['CompanyContactPerson'],
        'tradingName': !exists(json, 'TradingName') ? undefined : json['TradingName'],
        'countryOfIncorporation': !exists(json, 'CountryOfIncorporation') ? undefined : json['CountryOfIncorporation'],
        'countryOfOperation': !exists(json, 'CountryOfOperation') ? undefined : json['CountryOfOperation'],
        'sector': !exists(json, 'Sector') ? undefined : json['Sector'],
        'contactPerson': !exists(json, 'ContactPerson') ? undefined : json['ContactPerson'],
        'intermediaryType': !exists(json, 'IntermediaryType') ? undefined : json['IntermediaryType'],
        'intermediaryFirstName': !exists(json, 'IntermediaryFirstName') ? undefined : json['IntermediaryFirstName'],
        'intermediaryLastName': !exists(json, 'IntermediaryLastName') ? undefined : json['IntermediaryLastName'],
        'intermediaryDisplayName': !exists(json, 'IntermediaryDisplayName') ? undefined : json['IntermediaryDisplayName'],
        'intermediaryPreferredName': !exists(json, 'IntermediaryPreferredName') ? undefined : json['IntermediaryPreferredName'],
        'intermediaryCellphoneNumber': !exists(json, 'IntermediaryCellphoneNumber') ? undefined : json['IntermediaryCellphoneNumber'],
        'intermediaryEmailAddress': !exists(json, 'IntermediaryEmailAddress') ? undefined : json['IntermediaryEmailAddress'],
        'brokerageCode': !exists(json, 'BrokerageCode') ? undefined : json['BrokerageCode'],
        'brokerageName': !exists(json, 'BrokerageName') ? undefined : json['BrokerageName'],
        'clientPartySubType': !exists(json, 'ClientPartySubType') ? undefined : json['ClientPartySubType'],
    };
}

export function IntermediaryClientPlanDetailToJSON(value?: IntermediaryClientPlanDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'BookOfBusinessCode': value.bookOfBusinessCode,
        'SourceSystemCode': value.sourceSystemCode,
        'SourceSystemGroupCode': value.sourceSystemGroupCode,
        'EffectiveStartDate': value.effectiveStartDate === undefined ? undefined : (value.effectiveStartDate.toISOString()),
        'EffectiveEndDate': value.effectiveEndDate === undefined ? undefined : (value.effectiveEndDate.toISOString()),
        'IntermediaryCode': value.intermediaryCode,
        'ClientNumber': value.clientNumber,
        'PlanNumber': value.planNumber,
        'InvestmentName': value.investmentName,
        'InceptionDate': value.inceptionDate === undefined ? undefined : (value.inceptionDate.toISOString()),
        'PlanActiveFlag': value.planActiveFlag,
        'ProductCode': value.productCode,
        'ProductName': value.productName,
        'ProductType': value.productType,
        'ProductCategory': value.productCategory,
        'ProductProvider': value.productProvider,
        'JockeyFlag': value.jockeyFlag,
        'ServiceFlag': value.serviceFlag,
        'ExBrokerFlag': value.exBrokerFlag,
        'ClientPartyType': value.clientPartyType,
        'ClientTitle': value.clientTitle,
        'ClientInitials': value.clientInitials,
        'ClientFirstName': value.clientFirstName,
        'ClientLastName': value.clientLastName,
        'ClientDisplayName': value.clientDisplayName,
        'ClientPreferredName': value.clientPreferredName,
        'ClientIdentificationNumber': value.clientIdentificationNumber,
        'ClientDateOfBirth': value.clientDateOfBirth === undefined ? undefined : (value.clientDateOfBirth.toISOString()),
        'ClientPassportNumber': value.clientPassportNumber,
        'ClientPassportCountryOfIssuance': value.clientPassportCountryOfIssuance,
        'ClientCompanyName': value.clientCompanyName,
        'ClientCompanyRegistrationNumber': value.clientCompanyRegistrationNumber,
        'ClientCompanyInceptionDate': value.clientCompanyInceptionDate === undefined ? undefined : (value.clientCompanyInceptionDate.toISOString()),
        'ClientMaritalStatus': value.clientMaritalStatus,
        'Country': value.country,
        'Email': value.email,
        'EmploymentStatus': value.employmentStatus,
        'FICAStatus': value.fICAStatus,
        'MobileNumber': value.mobileNumber,
        'TaxNumber': value.taxNumber,
        'AddressStreetFarmPlotName': value.addressStreetFarmPlotName,
        'WorkTelephone': value.workTelephone,
        'HomeTelephone': value.homeTelephone,
        'NationalityCountry': value.nationalityCountry,
        'ResidenceCountry': value.residenceCountry,
        'PostalAddress': value.postalAddress,
        'Industry': value.industry,
        'SourceOfMoney': value.sourceOfMoney,
        'CompanyContactPerson': value.companyContactPerson,
        'TradingName': value.tradingName,
        'CountryOfIncorporation': value.countryOfIncorporation,
        'CountryOfOperation': value.countryOfOperation,
        'Sector': value.sector,
        'ContactPerson': value.contactPerson,
        'IntermediaryType': value.intermediaryType,
        'IntermediaryFirstName': value.intermediaryFirstName,
        'IntermediaryLastName': value.intermediaryLastName,
        'IntermediaryDisplayName': value.intermediaryDisplayName,
        'IntermediaryPreferredName': value.intermediaryPreferredName,
        'IntermediaryCellphoneNumber': value.intermediaryCellphoneNumber,
        'IntermediaryEmailAddress': value.intermediaryEmailAddress,
        'BrokerageCode': value.brokerageCode,
        'BrokerageName': value.brokerageName,
        'ClientPartySubType': value.clientPartySubType,
    };
}

